// in posts.js
import * as React from "react";
import { List, Datagrid, TextField, Filter, TextInput, Pagination, TopToolbar, CreateButton, DeleteButton, EditButton } from 'react-admin';

const ResiliationCategoryPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

const ResiliationCategoryActions = (props) => (
    <TopToolbar>
        <CreateButton />
    </TopToolbar>
);

const ResiliationCategoryFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Identifiant" source="id" alwaysOn />
        <TextInput label="Nom" source="name" alwaysOn />
        <TextInput label="Description" source="description" alwaysOn />
    </Filter>
);

export const ResiliationCategoryList = (props) => (
    <List {...props} pagination={<ResiliationCategoryPagination />} title="Motifs Préfectures" actions={<ResiliationCategoryActions />} filters={<ResiliationCategoryFilter />}>
        <Datagrid>
            <TextField label="Identifiant" source="id" />
            <TextField label="Nom" source="name" sortable={false} />
            <TextField label="URL" source="url" sortable={false} />
            <TextField label="Description" source="description" sortable={false} />
            <EditButton />
            <DeleteButton />
        </Datagrid>

    </List>
);